import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getGoogleSheet,
  getMyPrediction,
  getSpikes,
  getSymbolList,
} from "../action/api-services";
import StockAction from "../component/stockAction";
import moment from "moment";
import PageLoader from "../component/loader";
import DeliveryGraph from "../component/deliveryGraph";
import { useNavigate } from "react-router";
import {
  degAngle,
  NSE_filter_marketcap,
  NSE_filter_volume,
} from "../utils/constants";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";

const SpikesPage = () => {
  const [loader, setLoader] = useState(false);
  const [spikeData, setSpikeData] = useState([]);
  const [filterSpikeData, setFilterSpikeData] = useState([]);
  const [filterSpikeDataList, setFilterSpikeDataList] = useState([]);

  const [series, setSeries] = useState("EQ");
  const [predictionData, setPredictionData] = useState([]);
  const [todayData, setTodayData] = useState([]);
  const [todayDate, setTodayDate] = useState();
  const [symbolData, setSymbolData] = useState([]);

  const NSE_Past_date = useSelector((state) => state.pastDate.value);
  // const [startDate, setStartDate] = useState(NSE_Past_date[0]?.max_date);
  const [startDate, setStartDate] = useState(new Date());
  const token = useSelector((state) => state.userToken.value);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      let current_date = moment(startDate).format("DDMMYY");
      getSpikes("", token)
        .then(function (response) {
          setSpikeData(response.data.data);
          setFilterSpikeData(response.data.data); // Remvoe
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getMyPrediction(current_date, token)
        .then(function (response) {
          setPredictionData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getGoogleSheet("", token)
        .then(function (response) {
          setTodayDate(response.data.data.datetime);
          setTodayData(response.data.data.json_data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });

      getSymbolList(series, '', token)
        .then(function (response) {
          setSymbolData(response.data.data);
        })
        .catch(function (err) {
          console.log("Error", err);
        });
    } else {
      navigate(`/`);
    }
  }, [token, startDate]);

  useEffect(() => {
    if (filterSpikeData) {
      const filteredData = Object.entries(filterSpikeData)
        ?.map(([Date, symbolData]) => {
          // Filter entries inside the symbol data
          const filteredStocks = Object.entries(symbolData).filter(
            ([key, obj]) => {
              let MarketCap = series === "ETF" ? 0 : NSE_filter_marketcap;
              return (
                obj.details?.series === series &&
                obj.close_price > 60 &&
                parseInt(obj.details.MarketCap) >= MarketCap
              );
            }
          );

          // Return only if we have filtered entries
          if (filteredStocks.length > 0) {
            return {
              date: Date,
              stocks: filteredStocks,
            };
          }

          return null;
        })
        .filter((item) => item !== null) // Remove nulls
        .sort(
          (a, b) => parseFloat(b.sma_angle_14) - parseFloat(a.sma_angle_14)
        );

      //  console.log(">>>>>>>>>>>>>>>>>>>>", filteredData)

      setFilterSpikeDataList(filteredData);
      setLoader(true);
    }
  }, [filterSpikeData]);

  return (
    <React.Fragment>
      <div className="pageContainer">
        {loader === false ? (
          <PageLoader />
        ) : (
          <div className="pagewrap fullheight">
            <table>
              <thead>
                <tr key="item_0_0">
                  <th style={{ width: "140px" }}>Symbol</th>
                  <th style={{ width: "15px" }}></th>
                  <th style={{ width: "35px" }}></th>
                  <th style={{ width: "40px", textAlign: "left" }}>Strength</th>
                  <th style={{ width: "40px", textAlign: "left" }}>Series</th>
                  <th style={{ width: "120px", textAlign: "left" }}>Sector</th>
                  {/* <th style={{width:'135px', textAlign:'left'}}>Industry</th> */}
                  <th style={{ width: "65px", textAlign: "left" }}>Indices</th>
                  {/* <th style={{width:'65px', textAlign:'left'}}>RSI</th>
                            <th style={{width:'100px', textAlign:'left'}}>TR</th> */}
                  <th style={{ width: "110px", textAlign: "left" }}>Trends</th>
                  <th style={{ width: "65px" }}>P Closed</th>
                  <th style={{ width: "65px" }}>LTP</th>
                  <th style={{ width: "45px" }}>Chn%</th>
                  <th style={{ width: "45px" }}>TChn%</th>
                  {/* <th style={{width:'150px'}}>14 | 9 | 5 Deg&deg;</th> */}
                  <th style={{ width: "60px" }}>SMA200</th>
                  <th style={{ width: "60px" }}>14 P/L</th>
                  <th style={{ width: "60px" }}>
                    52 Down
                    {/* <button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('down_now')}}></button> */}
                  </th>
                  <th style={{ width: "80px" }}>52 L/H</th>
                  <th style={{ width: "75px" }}>AT Vol</th>
                  <th style={{ width: "40px" }}>Del %</th>
                  <th style={{ width: "30px" }}>News</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(filterSpikeDataList)?.map((item, index) => {
                  return (
                    <React.Fragment key={`item_0_1_${index}`}>
                      <tr>
                        <th
                          style={{ backgroundColor: "rgba(0, 0, 0, 0.10)" }}
                          colSpan={20}
                        >
                          {moment(item[1]["date"]).format("DD/MM/YYYY")} [
                          {item[1]["stocks"]?.length}]
                        </th>
                      </tr>
                      {item[1]["stocks"]?.map((obj, ind) => {
                        let symbolName = obj[1]["symbol"];
                        let todayLTP = todayData?.find(
                          (item, index) => item.TICKER === symbolName
                        );
                        let prediction = predictionData?.find(
                          (item, index) => item.symbol === symbolName
                        );
                        let trend = [
                          obj[1].method_deg ? "Deg" : "",
                          obj[1].method_cb ? "Breakout" : "",
                          obj[1].method_spike ? "Spike" : "",
                          obj[1].method_signal ? "Signal7" : "",
                          obj[1].method_woi ? "WOI" : "",
                          obj[1].method_consecutive ? "Cons" : "",
                          obj[1].method_engulf ? "Engulf" : "",
                        ]
                          .filter(Boolean)
                          .join(" | ");
                        // let prevVolume = (((parseInt(prediction?.ttl_trd_qty) - parseInt(prediction?.prev_ttl_trd_qty)) * 100)/parseInt(prediction?.prev_ttl_trd_qty)).toFixed(2);
                        // let angle_5 = degAngle(prediction?.price_5, todayLTP?.LTP, 5);
                        // let angle_9 = degAngle(prediction?.price_9, todayLTP?.LTP, 9);
                        // let angle_14 = degAngle(prediction?.price_14, todayLTP?.LTP, 14);

                        // console.log("todayLTP", todayData)
                        return (
                          <tr
                            className={`tr_${obj[1]["details"].id}`}
                            key={`row_item_${index + 1}_${ind + 1}`}
                            id={`row_item_${index + 1}_${ind + 1}`}
                          >
                            <td
                              id={`item_${index + 1}_${ind + 1}`}
                              className="symbolName"
                              title={`Spike Count: ${obj[1].spike_count}`}
                              style={{
                                backgroundColor:
                                  index === 0 &&
                                  // && parseFloat(obj[1]?.spike_count) > 2
                                  parseFloat(obj[1].spike_count) > 2 &&
                                  parseFloat(obj[1].datr) >
                                    parseFloat(obj[1].adtr)
                                    ? // && (parseFloat(obj[1].sma_angle_14) > parseFloat(obj[1].sma_angle_9)) && (parseFloat(obj[1].sma_angle_9) > parseFloat(obj[1].sma_angle_5))
                                      "#cde9d7"
                                    : "",
                              }}
                            >
                              {symbolName}{" "}
                              {obj[1].spike_count > 1
                                ? `[${obj[1].spike_count}]`
                                : ""}{" "}
                              {obj[1]["details"].hotStar === "1" ? (
                                <span className="hotStar"></span>
                              ) : null}
                            </td>
                            <td>
                              <StockAction
                                symbol={symbolName}
                                delivery={false}
                                currentPrice={obj[1].close_price}
                                deliveryPer={obj[1].delivery_per}
                                hotStar={obj[1]["details"].hotStar}
                                myFev={obj[1]["details"].myFev}
                                eventName={trend?.split("|")[0].trim()}
                                rowId={`row_item_${index + 1}_${ind + 1}`}
                              />
                            </td>
                            <td>
                              <DeliveryGraph
                                symbol={symbolName}
                                todayLTP={todayLTP}
                                date={moment(NSE_Past_date[0]?.max_date).format(
                                  "YYYY-MM-DD"
                                )}
                              />
                            </td>
                            <StockStrength
                              id={`spike_${index}`}
                              selectedDate={startDate}
                              symbol={symbolName}
                              todayLTP={todayLTP}
                              details={item.details}
                              predictions={prediction}
                            />
                            <td style={{ textAlign: "left" }}>
                              {obj[1].series}
                            </td>
                            <SectorPanchang
                              symbol={symbolName}
                              sector={todayLTP?.SECTOR}
                              todayData={todayData}
                              symbolData={symbolData}
                              tag = "td"
                              align = "right"
                              durationDays = ""
                            />
                            {/* <td style={{textAlign:'left', lineHeight:1.2}}>{obj[1]['details'].industry}</td> */}
                            <td
                              className="indices"
                              style={{ textAlign: "left" }}
                            >
                              {(() => {
                                const label = obj[1]["details"].nifty50
                                  ? "50"
                                  : obj[1]["details"].nifty100
                                  ? "100"
                                  : obj[1]["details"].nifty200
                                  ? "200"
                                  : obj[1]["details"].nifty500
                                  ? "500"
                                  : obj[1]["details"].totalMarket
                                  ? "TM"
                                  : "";
                                const excludedSeries = ["ETF", "BOND", "MF"];
                                const showFev =
                                  obj[1]["details"].myFev &&
                                  !excludedSeries.includes(
                                    obj[1]["details"].series
                                  );
                                return (
                                  label +
                                  (showFev ? `${label ? ", " : ""}Fev` : "")
                                );
                              })()}
                            </td>
                            {/* <td style={{textAlign:'left'}} className={(parseFloat(obj[1].adx) > 25)?"datrcolor":""} title={`Spikes Count | ADX:- ${parseFloat(obj[1].adx).toFixed(2)}`}>
                                                            {obj[1].spike_count}
                                                            {obj[1].rsi? " | " + obj[1].rsi :""}
                                                        </td> */}
                            {/* <td style={{textAlign:'right', color: ((parseFloat(obj[1].datr) > parseFloat(obj[1].adtr)) >= 1)?"#1c8b16":""}} title={(parseFloat(obj[1].datr) > parseFloat(obj[1].adtr))?"DATR > ADTR":""}>
                                                            {obj[1].datr} | {obj[1].adtr}
                                                        </td> */}
                            {/* If DATR > ADTR, volatility is increasing → Expect big price movements. */}
                            <td style={{ textAlign: "left" }}>{trend}</td>
                            <td>{obj[1].prev_close}</td>
                            <td>{todayLTP?.LTP?.toFixed(2)}</td>
                            <td
                              style={{
                                color:
                                  parseFloat(todayLTP?.CHANGEPER) > 0
                                    ? "#1c8b16"
                                    : "#f00",
                              }}
                            >
                              {todayLTP?.CHANGEPER}%
                            </td>
                            <td
                              style={{
                                color:
                                  parseFloat(
                                    ((todayLTP?.LTP - obj[1].prev_close) *
                                      100) /
                                      obj[1].prev_close
                                  ) > 0
                                    ? "#1c8b16"
                                    : "#f00",
                              }}
                            >
                              {(
                                ((todayLTP?.LTP - obj[1].prev_close) * 100) /
                                obj[1].prev_close
                              ).toFixed(2)}
                              %
                            </td>
                            {/* <td style={{textAlign:'right', backgroundColor: (parseFloat(angle_5) > parseFloat(angle_9)) && (parseFloat(angle_9) > parseFloat(angle_14))? '#e9ffe3':''}}>
                                                            {angle_14}&deg; | {angle_9}&deg; | {angle_5}&deg;
                                                        </td> */}
                            <td
                              style={{
                                textAlign: "right",
                                background:
                                  parseFloat(prediction?.sma50) >
                                  parseFloat(prediction?.sma200)
                                    ? "#e2ffe5"
                                    : "#fff8f8",
                              }}
                              title={`DMA50: ${prediction?.sma50}`}
                            >
                              {prediction?.sma200}
                            </td>
                            <td
                              title={`${obj[1].sma14} | ${moment(
                                obj[1].sma14_date
                              ).format("DD/MM/YYYY")}`}
                            >
                              {obj[1].price_14_date_PL}%
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {obj[1]["details"].high52w
                                ? (
                                    ((obj[1]["details"].high52w -
                                      obj[1].close_price) *
                                      100) /
                                    obj[1]["details"].high52w
                                  ).toFixed(2)
                                : ""}
                              %
                            </td>
                            <td
                              title={`${moment(
                                obj[1]["details"].lowDate
                              ).format("DD-MM-YY")} / ${moment(
                                obj[1]["details"].highDate
                              ).format("DD-MM-YY")}`}
                            >
                              {obj[1]["details"].low52w}/
                              {obj[1]["details"].high52w}
                            </td>
                            {/* <td className={(obj[1].delivery_spike === "Delivery Spike" && prevVolume > 100)?"datrcolor":""} title="Today Volume % | Prev Volume % ">{(((parseInt(todayLTP?.VOLUME) - parseInt(prediction?.ttl_trd_qty)) * 100) / parseInt(prediction?.ttl_trd_qty)).toFixed(2)} | {prevVolume} [{obj[1]['delivery_per']}%]</td> */}
                            <td>
                              {parseInt(todayLTP?.VOLUME).toLocaleString(
                                "en-IN"
                              )}
                            </td>
                            <td
                              title={`${
                                obj[1].delivery_spike === "Delivery Spike"
                                  ? "Delivery Spike"
                                  : ""
                              }`}
                            >
                              {obj[1]["delivery_per"]}%
                            </td>
                            <td>
                              <a
                                className="newsicon"
                                href={`https://www.google.com/search?q=why+${symbolName}+share+spiked+or+rising+on+${moment(
                                  obj[1].delivery_date
                                ).format("Do MMMM YYYY")}?`}
                                target="_blank"
                              ></a>
                            </td>
                          </tr>
                        );
                      })}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
export default SpikesPage;
